import OfferOutUrl from '@/components/shared/OfferOutUrl';
import { getBaseImageUrl, getMerchantHref } from '@/constants/hooks';
import { OffersMerchant, OffersOffer } from '@/services/dataTypes';
import Image from 'next/image'
import Link from 'next/link'
import React from 'react'

interface Props {
    data: OffersOffer;
    merchant?: OffersMerchant;
    height?: number;
    offerLink?: string | null;
    mer_slug?: string;
    slug_type?: string;
    domain: string;
    unoptimized?: boolean;
    width?: number;
}

const Banner = ({ data, height, offerLink, mer_slug, slug_type, domain, unoptimized = false, width }: Props) => {
    const { offer_title, offer_detail, banner_image, url } = data?.offer ?? {};

    return (
        <div className="group relative w-full">
            {/* Premium Banner Container */}
            <div className="relative overflow-hidden rounded-xl bg-gradient-to-br from-[#F8FAFC] to-[#F8FAFC] shadow-sm border border-[#E5E7EB] transition-all duration-300 hover:shadow-lg hover:border-[#F97316]">
                {/* Glow Effect on Hover */}
                <div className="absolute inset-0 bg-gradient-to-tr from-[#F97316]/5 to-[#EA580C]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />

                {mer_slug && slug_type ? (
                    <OfferOutUrl
                        outUrl={offerLink || url || ""}
                        unique_id={data?.offer?.unique_id || ""}
                        merchantHref={getMerchantHref(data?.merchant, mer_slug, slug_type)}
                        domain={domain}
                        customClass="block relative transition-transform duration-300 group-hover:scale-[1.02]"
                    >
                        <Image
                            src={getBaseImageUrl(domain, banner_image, "")}
                            alt={`${data?.merchant?.merchant_name || "Merchant"} exclusive discount coupons and deals`}
                            objectFit="contain"
                            className="mx-auto"
                            loading='lazy'
                            height={height}
                            width={width}
                            unoptimized={unoptimized}
                        />
                    </OfferOutUrl>
                ) : (
                    <Link
                        href={offerLink || url || ""}
                        rel="nofollow sponsored noopener noreferrer"
                        className="block relative transition-transform duration-300 group-hover:scale-[1.02]"
                    >
                        <Image
                            src={getBaseImageUrl(domain, banner_image, "")}
                            alt={offer_detail || offer_title || "Exclusive Offer Banner"}
                            layout='responsive'
                            height={height || 200}
                            width={width || 300}
                            objectFit="contain"
                            className="mx-auto"
                            loading='lazy'
                            unoptimized={unoptimized}
                        />
                    </Link>
                )}
            </div>
        </div>
    );
};

export default Banner
